import React, {useState} from 'react';
import './styles.scss'
import HeaderButton from "../pages/reports/components/button";
import {apiPost} from "../services/apiClient";
import {toast} from "react-toastify";
import ConfirmModal from "../components/Modals/ConfirmModal";

const DictionaryButtons = ({reload, selectedItems, clearFilters, clearDisabled, dictionaryData, setLoading}) => {
    const [deleteItems, setDelete] = useState(false);
    const deleteParcels = () => {
        setLoading(true);
        apiPost(`${dictionaryData.key}/delete`, {ids: selectedItems}).then(d => {
            d.warnings && toast.error(d.warnings)
            setDelete(false);
            !d.warnings && toast.success('Строки удалены')
            reload ? reload() : setLoading(false);
        }).catch(e => {
            setDelete(false);
            toast.error('При удалении произошла ошибка')
            setLoading(false)
            console.log(e)
        })
    }

    return (
        <div className='grid-btns'>
            <HeaderButton
                disabled={!selectedItems.length}
                icon='delete'
                name='Удалить'
                onClick={() => setDelete(true)}
            />
            <HeaderButton
                disabled={clearDisabled}
                icon='close'
                name='Сбросить фильтры'
                onClick={clearFilters}
            />
            <ConfirmModal
                open={deleteItems}
                setOpen={setDelete}
                label={`Удаление`}
                onConfirm={deleteParcels}
            >
                Вы уверены, что хотите удалить выбранные строки?
            </ConfirmModal>
        </div>
    );
};

export default DictionaryButtons;


// WEBPACK FOOTER //
// ./App/grids/dictionaryButtons.jsx